<template>
  <b-modal
    id="my-import-contacts-org-popup"
    centered
    hide-footer
    hide-header
    body-class="my-import-contacts-org-popup"
    size="lg"
    @hidden="onHide"
  >
    <button
      @click="hideModal"
      class="tw-absolute tw-top-[20px] tw-right-[20px] tw-grid tw-place-items-center tw-w-[40px] tw-h-[40px] tw-border-[1px] tw-border-transparent tw-text-[#d9d9d9] hover:tw-text-[var(--my-text-color)] tw-transition-colors"
    >
      <icon-close />
    </button>

    <h3 class="tw-text-center tw-text-[25px] tw-font-black tw-mb-[34px]">
      {{ $t("donor_dashboard.my_contacts_popup_title_import_contacts", "Import Contacts") }}
    </h3>

    <p class="tw-text-center tw-mb-[20px]">
      {{ $t("donor_dashboard.my_contacts_import_notice", "You can download a sample XLSX file ") }}
      <a
        :href="sampleFileUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="tw-text-[var(--my-primary)] tw-underline"
      >
        {{ $t("donor_dashboard.my_contacts_import_notice_link", "here") }}
      </a>
    </p>

    <div class="tw-mb-[30px]">
      <my-form-input
        :label="$t('donor_dashboard.my_contacts_import_file_label', 'Select XLSX file')"
        readonly
        :value="fileName"
        @click.native="triggerFileInput"
        class="tw-cursor-pointer"
      >
        <template #icon>
          <b-icon-upload />
        </template>
      </my-form-input>
      <input
        ref="hiddenInput"
        type="file"
        accept=".xlsx"
        @change="onFileChange"
        class="tw-hidden"
      />
    </div>

    <div v-if="error" class="tw-text-red-500 tw-mb-2 text-center">{{ error }}</div>
    <div v-if="success" class="tw-text-green-500 tw-mb-2 text-center">
      {{ $t("donor_dashboard.my_contacts_import_success", "Contacts imported successfully!") }}
    </div>

    <div class="tw-text-center">
      <my-btn btnStyle="my-primary" :loading="loading" @click="submitImport">
        {{ $t("donor_dashboard.my_contacts_import_btn", "Import") }}
      </my-btn>
    </div>
  </b-modal>
</template>

<script>
import iconClose from "@/views/my-contacts/icons/close.vue";
import myFormInput from "@/views/my-contacts/ui/my-form-input.vue";
import myBtn from "@/views/my-contacts/ui/my-btn.vue";
import { useTeamLeaderContacts } from "@/composables/useDashboardTeamLeaderContacts";

export default {
  components: { iconClose, myFormInput, myBtn },

  data() {
    return {
      file: null,
      loading: false,
      error: null,
      success: false,
      sampleFileUrl:
        "https://b313e8803f7a4150a884-6e0b076a1e92e31c40be44f466689c50.ssl.cf5.rackcdn.com/Sample%20Contact%20Import%20Org%20Dashboard%20v2.xlsx",
    };
  },

  setup() {
    const teamLeaderContacts = useTeamLeaderContacts();
    return { teamLeaderContacts };
  },

  computed: {
    fileName() {
      return this.file
        ? this.file.name
        : this.$t("donor_dashboard.my_contacts_import_placeholder", "Choose file");
    },
  },

  methods: {
    triggerFileInput() {
      this.$refs.hiddenInput?.click();
    },

    onFileChange(e) {
      const files = e.target.files;
      this.file = files && files.length ? files[0] : null;
    },

    openModal() {
      this.$root.$emit("bv::show::modal", "my-import-contacts-org-popup");
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "my-import-contacts-org-popup");
    },

    onHide() {
      // reset state
      this.file = null;
      this.loading = false;
      this.error = null;
      this.success = false;
    },

    async submitImport() {
      if (!this.file) {
        this.error = this.$t(
          "donor_dashboard.my_contacts_import_error_no_file",
          "Please select a file"
        );
        return;
      }
      this.loading = true;
      this.error = null;
      try {
        await this.teamLeaderContacts.importContactsXlsx(this.file);
        this.success = true;
        await this.teamLeaderContacts.fetchContacts({
          campaign_id: this.teamLeaderContacts.campaignId.value,
          team_id: this.teamLeaderContacts.teamId.value,
        });
        this.hideModal();
      } catch (err) {
        const errors = err.errors.map((error) => error.message).join("; ");
        this.error =
          err.errors.length > 0
            ? `${err.message}${errors ? `: ${errors}` : ""}`
            : this.$t("donor_dashboard.my_contacts_import_error", "Import failed");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog .modal-content {
  @apply md:tw-rounded-[20px];
}

::v-deep .modal-dialog .my-import-contacts-org-popup {
  @apply tw-pt-[60px] tw-px-[44px] tw-pb-[84px] md:tw-pb-[40px] md:tw-rounded-[20px] tw-font-lato tw-text-[var(--my-text-color)] tw-leading-[var(--my-leading)] tw-bg-[var(--my-white)];
}
</style>
